/* eslint-disable default-case */
import { Axios } from "../../service/serviceBasic";
import { stepsFormGrupos } from "../../service/stepsService";
import {
  TIPO_PESSOA_SELECIONAR,
  TIPO_NECESSIDADE_SELECIONAR,
  TIPO_PRODUTO_SELECIONAR,
  SET_TIPO_PRODUTO,
  LOADING_TIPO_PRODUTO,
  ERROR_TIPO_PRODUTO,
  VALUE_TIPO_PRODUTO,
  SET_TIPO_CONTRATO,
  SET_LOGO_PARCEIRO
} from "./types";
import {
  setCurrentNavegationStepsAction,
  setCurrentStepAction,
  setNavegationStepsAction,
} from "../navegationSteps/actions";
import { identity } from "lodash";

import {
  SET_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  SET_CODIGO_GERENTE_VIA_LINK,
  CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
  LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE
} from "../dadosIniciaisPF/types";
import {
  SET_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  SET_CODIGO_GERENTE_VIA_LINK_PJ,
  CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM,
  LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE
} from "../dadosIniciaisPJ/types";

export const selecionarTipoPessoaAction = (event) => (dispatch, getState) => {
  let { tipoCadastroReducer, navegationStepsReducer } = getState();
  dispatch(setValueTipoProdutoAction());
  dispatch({
    type: TIPO_PESSOA_SELECIONAR,
    payload: event.value,
  });

  if (tipoCadastroReducer.tipoProdutoValue) {
    let produtos = navegationStepsReducer.navegations[event.value].Produtos;
    let currentNavegation = produtos.find((i) => {
      return i.Id === tipoCadastroReducer.tipoProdutoValue;
    });

    dispatch(setCurrentNavegationStepsAction(currentNavegation || {}));
    dispatch(setCurrentStepAction(stepsFormGrupos(currentNavegation)[0]));
  }
};

export const selecionarTipoNecessidadeAction = (event) => (dispatch, getState) => {
  dispatch({
    type: TIPO_NECESSIDADE_SELECIONAR,
    payload: event.value,
  });

  dispatch(setValueTipoProdutoAction());
};

export const selecionarTipoProdutoAction = (event) => (dispatch, getState) => {
  let { tipoCadastroReducer, navegationStepsReducer } = getState();
  dispatch({
    type: TIPO_PRODUTO_SELECIONAR,
    payload: event.value,
  });

  if (tipoCadastroReducer.tipoPessoaValue) {
    let produtos = navegationStepsReducer.navegations[tipoCadastroReducer.tipoPessoaValue].Produtos;
    let currentNavegation = produtos.find((i) => {
        return i.Id === event.value;
    });

    dispatch(setCurrentNavegationStepsAction(currentNavegation || {}));
    dispatch(setCurrentStepAction(stepsFormGrupos(currentNavegation)[0]));
  }
};

export const refreshTipoContratoAction = (produtoList) => (
  dispatch,
  getState
) => {
  let { tipoCadastroReducer } = getState();

  let stringParts = {};

  switch (tipoCadastroReducer.tipoNecessidade) {
    case "EnviarParaExterior":
      stringParts.operacao = "enviar valores para o exterior, ";
      break;
    case "ReceberDoExterior":
      stringParts.operacao = "receber valores do exterior, ";
      break;
  }

  switch (tipoCadastroReducer.tipoPessoaValue) {
    case "PessoaFisica":
      stringParts.pessoa = "Pessoa física com pretensão de ";
      break;
    case "PessoaJuridica":
      stringParts.pessoa = "Pessoa juridica com pretensão de ";
      break;
  }

  let produto;
  if (tipoCadastroReducer.tipoProdutoValue)
    produto = produtoList.find(function (element) {
      return element.value === tipoCadastroReducer.tipoProdutoValue;
    }).label;
  else produto = "produto não selecionado";

  let result =
    stringParts.pessoa +
    stringParts.operacao +
    produto.charAt(0).toLowerCase() +
    produto.replace("¹", "").substring(1, produto.length) +
    ".";

  dispatch(setTipoContrato(result));
};

export const refreshStepDadosBancario = (produtoList) => (
  dispatch,
  getState
) => {
  let { tipoCadastroReducer, navegationStepsReducer } = getState();

  let navegation = navegationStepsReducer.navegations;
  let gruposProdutos;
  switch (tipoCadastroReducer.tipoPessoaValue) {
    case "PessoaFisica": {
      if (tipoCadastroReducer.tipoProdutoValue) {
        let dadosBancariosGrupoOld;
        gruposProdutos = navegation.PessoaFisica.Produtos.find(
          (x) => x.Id === tipoCadastroReducer.tipoProdutoValue
        );
        let dadosBancariosGrupo = gruposProdutos.Grupos.find((x) => x.Id === 9);

        if (gruposProdutos.GruposOld)
          dadosBancariosGrupoOld = gruposProdutos.GruposOld.find(
            (x) => x.Id === 9
          );
        if (tipoCadastroReducer.tipoNecessidade === "ReceberDoExterior") {
          if (!dadosBancariosGrupo) {
            if (dadosBancariosGrupoOld) {
              gruposProdutos.Grupos.splice(
                dadosBancariosGrupoOld.IdEsteira - 1,
                0,
                dadosBancariosGrupoOld
              );
            }
          }
        } else {
          gruposProdutos.GruposOld = [];
          gruposProdutos.GruposOld.push(dadosBancariosGrupo);
          const index = gruposProdutos.Grupos.indexOf(dadosBancariosGrupo);
          gruposProdutos.Grupos.splice(index, 1);
        }
      }

      if (navegation) dispatch(setNavegationStepsAction(navegation));
      if (gruposProdutos)
        dispatch(setCurrentNavegationStepsAction(gruposProdutos));

      break;
    }
    case "PessoaJuridica": {
      if (tipoCadastroReducer.tipoProdutoValue) {
        let dadosBancariosGrupoOld;
        gruposProdutos = navegation.PessoaJuridica.Produtos.find(
          (x) => x.Id === tipoCadastroReducer.tipoProdutoValue
        );
        let dadosBancariosGrupo = gruposProdutos.Grupos.find((x) => x.Id === 9);

        if (gruposProdutos.GruposOld)
          dadosBancariosGrupoOld = gruposProdutos.GruposOld.find(
            (x) => x.Id === 9
          );
        if (tipoCadastroReducer.tipoNecessidade === "ReceberDoExterior") {
          if (!dadosBancariosGrupo) {
            if (dadosBancariosGrupoOld) {
              gruposProdutos.Grupos.splice(
                dadosBancariosGrupoOld.IdEsteira - 1,
                0,
                dadosBancariosGrupoOld
              );
            }
          }
        } else {
          gruposProdutos.GruposOld = [];
          gruposProdutos.GruposOld.push(dadosBancariosGrupo);
          const index = gruposProdutos.Grupos.indexOf(dadosBancariosGrupo);
          gruposProdutos.Grupos.splice(index, 1);
        }
      }

      if (navegation) dispatch(setNavegationStepsAction(navegation));
      if (gruposProdutos)
        dispatch(setCurrentNavegationStepsAction(gruposProdutos));

      break;
    }
  }
};

// ==================== PARA QUANDO CODIGO FORNECIDO PELA URL ====================
export const setDadosIniciaisCodigoGerenteAction = (data, query = false) => (
  dispatch
) => {
  dispatch({
    type: SET_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
    payload: data,
  });
  dispatch({
    type: SET_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
    payload: data,
  });
  dispatch(getDadosIniciaisGerenteAction(data, query));
};


export const getDadosIniciaisGerenteAction = (value, query = false) => (
  dispatch,
  getState
) => {
  let { dadosIniciaisPFReducer, dadosIniciaisPJReducer } = getState();
  let formPFValues = dadosIniciaisPFReducer.formPF;
  let formPJValues = dadosIniciaisPJReducer.formPJ;

  let request = {
    IdGerente: value,
  };

  dispatch(loadingDadosIniciaisCodigoGerenteAction(true));
  return Axios.post("v1/basico/gerente/obterDadosGerente", request)
    .then((response) => {
      
      formPFValues["dadosIniciais_nomeGerente"] = response.data.Nome;
      dispatch({
        type: CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
        payload: formPFValues,
      });

      formPJValues["dadosIniciais_nomeGerente"] = response.data.Nome;
      dispatch({
        type: CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM,
        payload: formPJValues,
      });

      if (query) {
        dispatch({
          type: SET_CODIGO_GERENTE_VIA_LINK,
          payload: true,
        });
        dispatch({
          type: SET_CODIGO_GERENTE_VIA_LINK_PJ,
          payload: true,
        });
      }

      dispatch(setErrorDadosIniciaisCodigoGerenteAction(""));
    })
    .then(() => {
      // ===== REQUISÃO PARA LOGO DO PARCEIRO =====
      Axios.post("v1/basico/gerentelogo/get", request)
      .then((response) =>
        dispatch({
          type: SET_LOGO_PARCEIRO,
          payload: response.data,
        }))
    })
    .catch((error) => {
      dispatch(setErrorDadosIniciaisCodigoGerenteAction(error.message));
      dispatch(resetDadosIniciais_NomeGerenteAction(formPFValues, formPJValues));
    })
    .finally(() => {
      dispatch(loadingDadosIniciaisCodigoGerenteAction(false));
    });
}

const resetDadosIniciais_NomeGerenteAction = (formPFValues, formPJValues) => (
  dispatch
) => {
  formPFValues["dadosIniciais_nomeGerente"] = "";
  formPJValues["dadosIniciais_nomeGerente"] = "";
  dispatch({
    type: CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
    payload: formPFValues,
  });
  dispatch({
    type: CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM,
    payload: formPJValues,
  });
}
const loadingDadosIniciaisCodigoGerenteAction = (flag) => (
  dispatch
) => {
  dispatch({
    type: LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
    payload: flag,
  });
  dispatch({
    type: LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
    payload: flag,
  });
}
const setErrorDadosIniciaisCodigoGerenteAction = (message) => (
  dispatch
) => {
  dispatch({
    type: ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
    payload: message,
  });
  dispatch({
    type: ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
    payload: message,
  });
}
// ==================== FIM ====================

const setTipoContrato = (data) => ({
  type: SET_TIPO_CONTRATO,
  payload: data,
});

const loadingListTipoProdutoAction = (flag) => ({
  type: LOADING_TIPO_PRODUTO,
  payload: flag,
});
const setListTipoProdutoAction = (list) => ({
  type: SET_TIPO_PRODUTO,
  payload: list,
});
const setErrorListTipoProduto = (message) => ({
  type: ERROR_TIPO_PRODUTO,
  payload: message,
});

const setValueTipoProdutoAction = () => ({
  type: VALUE_TIPO_PRODUTO,
  payload: null,
});

export const getListTipoProdutoAction = () => (dispatch) => {
  dispatch(loadingListTipoProdutoAction(true));
  return Axios.post("/v1/cliente/produto/list", {})
    .then((response) => {
      dispatch(setListTipoProdutoAction(response.data));
    })
    .catch((error) => {
      dispatch(setErrorListTipoProduto(error.message));
    })
    .finally(() => {
      dispatch(loadingListTipoProdutoAction(false));
    });
};
